export default __webpack_public_path__ + "static/media/bg.00e8e25f.svg";